import TransferForm from '../../../banking/components/transfers/TransferForm';

const TransferPage = () => {
    return <TransferForm />;
};

export default TransferPage;
